<template>
  <p class="ma-1">
    {{ resultCount }}
  </p>
</template>

<script>
export default {
  name: "ResultCount",
  props: {
    total: {
      type: Number,
      default: () => 1,
      required: true
    },
    pageSize: {
      type: Number,
      default: () => 1,
      required: true
    },
    currentPage: {
      type: Number,
      default: () => 1,
      required: true
    }
  },
  computed: {
    resultCount() {
      if (this.total === 0) {
        return `0 results`;
      } else {
        const first = (this.currentPage - 1) * this.pageSize + 1;
        const roundedLast = this.currentPage * this.pageSize;
        const last = this.total < roundedLast ? this.total : roundedLast;
        return `${first} - ${last} of ${this.total}`;
      }
    }
  }
};
</script>
